/**
 * Math.round doesn't handle floating point numbers well, so this handles rounding away from zero.
 * See: https://stackoverflow.com/a/41716722
 * @param value the number to round
 * @param decimals the number of decimals to round to
 */
export function round(value: number, decimals: number): number {
  if (!value) return 0;

  // Round away from zero, so if the number is negative, subtract epsilon
  const direction = value > 0 ? +1 : -1;
  const epsilon = direction * Number.EPSILON;

  const scale = Math.pow(10, decimals);
  return Math.round((value + epsilon) * scale) / scale;
}
